import { Helmet } from "react-helmet-async";

export default function SecureWorkshopPage() {
  return (
    <>
      <Helmet>
        <title>Workshop | Calm But Capable</title>
        <meta name="robots" content="noindex,nofollow" />
      </Helmet>

      <main className="entry-container">
      <header className="entry-header">
        <div className="entry-brand">
          <img
            src="/logo-white.png"
            alt="Calm But Capable"
            className="entry-logo-small"
          />

          <div>
            <div className="entry-brand-name">Calm But Capable</div>
            <div className="entry-brand-subtitle">Free Workshop</div>
          </div>
        </div>
      </header>

      <section className="entry-card">
        <p className="entry-eyebrow">Free Workshop</p>

        <h1 className="entry-title">
          Why Slowing Down Often Speeds You Up
        </h1>

        <p className="entry-tagline">
          Take your time. Watch at your own pace.
        </p>

        <p className="entry-subtitle">
          This workshop is designed to help you slow the noise down, identify
          what matters next, and take one manageable step without trying to
          solve everything at once.
        </p>

        <div
          style={{
            width: "100%",
            maxWidth: "720px",
            margin: "3rem auto 2.5rem auto",
            borderRadius: "12px",
            overflow: "hidden",
          }}
        >
          <iframe
            src="https://player.vimeo.com/video/1198352567?h=5393c3990d"
            title="Why Slowing Down Often Speeds You Up"
            style={{
              display: "block",
              width: "100%",
              aspectRatio: "16 / 9",
              border: "none",
              borderRadius: "12px",
            }}
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
          />
        </div>

        <section className="entry-section">
          <h2 className="entry-section-title">
            Download Your Companion Guide
          </h2>

          <p className="entry-paragraph">
            After watching the workshop, use the companion guide to apply the
            ideas to your own life and identify your next useful step.
          </p>

          <button
            className="entry-button"
            onClick={() =>
                window.open(
                "/downloads/CBC-Why-Slowing-Down-Often-Speeds-You-Up-Companion-Workbook.pdf",
                "_blank"
                )
            }
            >
            Download Companion Guide
            </button>
        </section>

        <section className="entry-section">
          <h2 className="entry-section-title">Remember</h2>

          <p className="entry-subtitle">
            You do not need to do everything today.
          </p>

          <p className="entry-subtitle">
            You only need to identify the next useful step.
          </p>

          <p className="entry-subtitle">
            Calm But Capable — let's begin.
          </p>
        </section>
      </section>
    </main>
     </>
  );
}